import {useCallback, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';
import {getEcaFields} from '../../api/EcaServices';
import {
  FieldUITypeMappingByValue,
  IFieldModal,
} from '../../components/pages/field-management/custom-field/constant';

export const useGetEcaFields = () => {
  const clientId = useSelector(
    (state: RootState) => state.selectedClient.clientId
  );
  const projectId = useSelector((state: RootState) => state.reports.projectId);

  const [state, setState] = useState({
    isLoading: false,
    fields: [] as IFieldModal[],
    isFailedToLoadContent: false,
  });
  const requestId = useRef(0);

  const getFields = useCallback(async () => {
    const currentRequestId = ++requestId.current;

    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      isFailedToLoadContent: false,
    }));

    try {
      const params = `clientId=${clientId}&projectId=${projectId}&filter=fieldTypeId eq ${FieldUITypeMappingByValue['Tag']}`;
      const result = await getEcaFields(params);
      if (currentRequestId !== requestId.current) return;

      setState((prevState) => ({
        ...prevState,
        fields: result?.data?.data ?? [],
      }));
    } catch {
      // error intentionally ignored, handled via isFailedToLoadContent flag
      if (currentRequestId !== requestId.current) return;

      setState((prevState) => ({...prevState, isFailedToLoadContent: true}));
    } finally {
      if (currentRequestId === requestId.current) {
        setState((prevState) => ({...prevState, isLoading: false}));
      }
    }
  }, [clientId, projectId]);

  return {
    getFields,
    isLoading: state.isLoading,
    fields: state.fields,
    isFailedToLoadContent: state.isFailedToLoadContent,
  };
};
